import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PublicLayout, PageContainer } from "@/components/PublicLayout";
import { ResultCard } from "@/components/ResultCard";
import { NavGrid } from "@/components/NavGrid";
import { SeoContent } from "@/components/SeoContent";
import { useSeo } from "@/lib/useSeo";
import { CalendarBlank } from "@phosphor-icons/react";

export default function Home() {
  useSeo({
    title: "Guwahati Morning Teer Result Today | Morning Teer Guwahati F/R S/R",
    description: "Guwahati Morning Teer result today - First Round (10:30 AM) and Second Round (11:30 AM), Common Number, Dream Number, Previous Result and full archive. Updated daily (Asia/Kolkata).",
    path: "/",
  });
  const dateQ = useQuery({ queryKey: ["date"], queryFn: async () => (await api.get("/date/today")).data });
  const resultQ = useQuery({ queryKey: ["today-result"], queryFn: async () => (await api.get("/results/today")).data });

  return (
    <PublicLayout>
      {/* Hero band */}
      <div className="relative bg-gradient-to-b from-brand-light/60 to-white pt-7 pb-6">
        <PageContainer>
          <div className="flex items-center justify-center gap-2 mb-4 text-brand" data-testid="today-date">
            <CalendarBlank className="w-5 h-5" weight="duotone" />
            <span className="font-heading font-bold text-sm sm:text-base tracking-wide">
              {dateQ.data?.display || "Loading date…"}
            </span>
          </div>

          <div className="w-full max-w-[1100px] mx-auto">
            <ResultCard result={resultQ.data} dateDisplay={resultQ.data?.display || dateQ.data?.display} loading={resultQ.isLoading} />
          </div>

          <p className="text-center text-xs text-slate-400 mt-4 max-w-md mx-auto">
            Results are shown in India Standard Time (Asia/Kolkata) and are for informational purposes only.
          </p>
        </PageContainer>
      </div>

      {/* 3x3 grid */}
      <PageContainer className="mt-8">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-xl sm:text-2xl font-black text-slate-900">Explore</h2>
          <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Quick Access</span>
        </div>
        <NavGrid />
      </PageContainer>

      {/* SEO content */}
      <PageContainer>
        <SeoContent page="home" />
      </PageContainer>
    </PublicLayout>
  );
}
